"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CourierProvider", {
  enumerable: true,
  get: function get() {
    return _reactProvider.CourierProvider;
  }
});
Object.defineProperty(exports, "Inbox", {
  enumerable: true,
  get: function get() {
    return _Inbox["default"];
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header["default"];
  }
});
Object.defineProperty(exports, "TextElement", {
  enumerable: true,
  get: function get() {
    return _styled.TextElement;
  }
});

var _reactProvider = require("@trycourier/react-provider");

var _Inbox = _interopRequireDefault(require("./Inbox"));

var _Header = _interopRequireDefault(require("./Messages2.0/Header"));

var _styled = require("./Messages2.0/styled");